import { Filter, FilterProps } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { useDeviceContext } from 'src/context/device.context';
import { useStores } from 'src/hooks/query/use-stores';
import { useUsers } from 'src/hooks/query/use-users';
import { getFilterConfig } from './config';
import { TabType } from '../list';

type MostFilterProps = Omit<FilterProps, 'items'> & {
  activeTab: TabType;
};

export const MostFilter = ({ activeTab, ...props }: MostFilterProps) => {
  const { t } = useTranslation();

  const { isMobile } = useDeviceContext();

  const size = isMobile ? 2 : 3;

  const filterItems = getFilterConfig({ t, size, activeTab });

  return (
    <div className="flex justify-between">
      <Filter
        {...props}
        items={filterItems}
        searchInputProps={{
          placeholder: t('most.list.filter.search.placeholder'),
        }}
      />
    </div>
  );
};
